var c = (r, p, i) => new Promise((a, n) => {
  var s = (e) => {
    try {
      t(i.next(e));
    } catch (o) {
      n(o);
    }
  }, l = (e) => {
    try {
      t(i.throw(e));
    } catch (o) {
      n(o);
    }
  }, t = (e) => e.done ? a(e.value) : Promise.resolve(e.value).then(s, l);
  t((i = i.apply(r, p)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function g(r) {
  return c(this, null, function* () {
    const {
      data: p
    } = yield d.post(
      "/designordercenter/productionOrder/specialApply/createSpecialShipping",
      r
    );
    return p == null ? void 0 : p.data;
  });
}
export {
  g as postCreateSpecialShipping
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/specialApply/createSpecialShipping/post.js
// module id = 1824
// module chunks = 67